export const getActiveOrganizations = (userState) => {
    return Object.keys(userState.orgRole);
};
